<template>
  <v-layout class="d-flex flex-wrap">
    <v-flex class="d-flex justify-center full_width mb-4">
      <div
        ref="dashboard"
        class="dashboard"
        style="width: 80vw;"
      >
        <vue-cropper
          class="preview"
          ref="cropper"
          alt="Upload Image"
          :src="svgPath"
          :zoomable="false"
          :autoCropArea="0.95"
          :toggleDragModeOnDblclick="false"
          :dragMode="'none'"
          @ready="cropperIsReady"
        >
        </vue-cropper>
      </div>
    </v-flex>
    <v-flex class="d-flex justify-center full_width mb-4">
      <div class="d-flex flex-nowrap justify-space-between rotate_button px-1">
        <v-btn
          @click="onRotate(-90)"
        >90°<br>{{ $t('step-two.left')}}</v-btn>
        <v-btn
          @click="onRotate(90)"
        >90°<br>{{ $t('step-two.right')}}</v-btn>
        <v-btn
          @click="onRotate(-5)"
        >5°<br>{{ $t('step-two.left')}}</v-btn>
        <v-btn
          @click="onRotate(5)"
        >5°<br>{{ $t('step-two.right')}}</v-btn>
        <v-btn
          @click="reset()"
        >{{ $t('step-two.reset')}}</v-btn>
      </div>
    </v-flex>
    <v-flex v-if="isMobile" class="d-flex justify-center text-center full_width">
      <p class="page_note">{{ $t('step-two.note')}}</p>
    </v-flex>
    <v-flex v-if="isMobile"  class="d-flex justify-center full_width">
      <div class="d-flex flex-nowrap justify-space-between">
        <v-btn
          class="primary_button button_back mr-1"
          @click="onBackStep"
        >
          {{ $t('buttons.back') }}
        </v-btn>
        <v-btn
          class="primary_button ml-1"
          @click="onNextStep"
        >
          {{ $t('buttons.next') }}
        </v-btn>
      </div>
    </v-flex>

    <loading-modal ref="LoadingModal"/>
  </v-layout>
</template>

<script>
import VueCropper from 'vue-cropperjs';
import LoadingModal from "@/components/home/loading-modal";
import FileService from "@/services/FileService";
import {mapGetters} from "vuex";


export default {
  name: "StepTwoComponent",
  mixins: [FileService],
  components: {
    'loading-modal': LoadingModal,
    VueCropper
  },
  props: {
    svgPath: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      timer: null,
      timer1: null,
      imageId: null
    }
  },
  computed: {
    ...mapGetters('cropperData', [
      'cropperHeight',
      'cropperWidth',
      'cropperTop',
      'cropperLeft',
      'cropperRotate',
    ]),
  },
  mounted() {
    this.changeCanvasHeight()
    this.$refs.LoadingModal.isModalOpen = true
  },
  methods: {
    changeCanvasHeight() {
      const dashboardWidth = this.$refs.dashboard.offsetWidth;
      this.$refs.dashboard.style.height = dashboardWidth + 'px';
      const cropperContainer = document.querySelector('.cropper-container')

      if(cropperContainer) {
        cropperContainer.style.height = dashboardWidth + 'px';
      }
    },
    getImageTopPosition(imageHeight) {
      return (this.$refs.dashboard.offsetHeight - imageHeight) / 2
    },
    getImageLeftPosition(imageWidth) {
      return (this.$refs.dashboard.offsetWidth - imageWidth) / 2
    },
    setDataForCanvas() {
      const canvasData = this.$refs.cropper.getCanvasData()
      const width = canvasData.width * 0.7
      const height = canvasData.height * 0.7
      this.$refs.cropper.setCanvasData({
        left: this.getImageLeftPosition(width),
        top: this.getImageTopPosition(height),
        width: width,
        height: height,
      })
    },
    reset() {
      this.$refs.cropper.reset()
      this.cropperIsReady()
    },
    onBackStep() {
      this.$emit('onBackStep')
    },
    onNextStep() {
      this.$refs.LoadingModal.isModalOpen = true
      this.saveCropperBoxData()
      this.uploadImage()
    },
    setCropperBoxData() {
      if (this.cropperHeight !== null && this.cropperWidth !== null) {
        this.$refs.cropper.setCropBoxData({
          left: this.cropperLeft,
          top: this.cropperTop,
          width: this.cropperWidth,
          height: this.cropperHeight,
        })

        this.onRotate(this.cropperRotate)
      }
    },
    saveCropperBoxData() {
      const cropBoxData = this.$refs.cropper.getCropBoxData()
      const cropData = this.$refs.cropper.getData()
      this.$store.dispatch('cropperData/setCropperHeight', cropBoxData.height)
      this.$store.dispatch('cropperData/setCropperWidth', cropBoxData.width)
      this.$store.dispatch('cropperData/setCropperTop', cropBoxData.top)
      this.$store.dispatch('cropperData/setCropperLeft', cropBoxData.left)
      this.$store.dispatch('cropperData/setCropperRotate', cropData.rotate)
    },
    uploadImage() {
      const payload = new FormData
      payload.append('file', this.dataURLtoFile(this.getCroppedImage(), "cleanedImage.jpg"));
      this.uploadFileForConvert(payload)
        .then((response) => {
          this.imageId = response.data
          this.getSvgFile()
        })
        .catch((err) => {
          console.log('error', err)
          this.onCallToastr('error', 'Something went wrong, please try again later', 'Failed!')
        })
    },
    dataURLtoFile(dataUrl, filename) {
      const arr = dataUrl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const binaryString = atob(arr[1])
      let counter = binaryString.length
      let u8arr = new Uint8Array(counter)

      while (counter--) {
        u8arr[counter] = binaryString.charCodeAt(counter);
      }

      return new File([u8arr], filename, {type: mime});
    },
    checkConvertToSvg() {
      const params = {
        'unique_id': this.imageId
      }
      this.checkToCovertFile(params)
        .then((response) => {
          this.isConverted = !!response.data
        })
        .catch((err) => {
          console.log('error', err)
          this.onCallToastr('error', 'Something went wrong, please try again later', 'Failed!')
        })
    },
    getSvgFile() {
      const counter = 0
      this.recursiveConversionRequest(counter)
    },
    recursiveConversionRequest(counter) {
      counter++
      if (counter > 200) {
        clearTimeout(this.timer)
        return false;
      }

      this.checkConvertToSvg()
      if (!this.isConverted) {
        this.timer = setTimeout(() => {
          this.recursiveConversionRequest(counter)
        }, 500)
      } else {
        clearTimeout(this.timer)
        this.$refs.LoadingModal.isModalOpen = false
        this.$store.dispatch('canvasHistory/setCanvasHistoryNextState', null)
        this.$emit('getCroppedImage', this.imageId)
        this.$emit('onNextStep')
      }
    },
    onRotate(value) {
      this.$refs.cropper.rotate(value);
    },
    getCroppedImage() {
      return this.$refs.cropper.getCroppedCanvas().toDataURL();
    },
    cropperIsReady() {
      this.setDataForCanvas()
      this.setCropperBoxData()
      this.$refs.LoadingModal.isModalOpen = false
    },
  },
  watch: {
    "innerWidth": function () {
      clearTimeout(this.timer1)
      this.timer1 = setTimeout(() => {
        this.changeCanvasHeight()
        this.reset()
        this.setDataForCanvas()
      }, 0)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer)
    clearTimeout(this.timer1)
  },
};
</script>
